import { utils } from './utils.js';
import { cameras } from './view/cameras.js';
import { userimage } from './tools/userimage.js';
import { settings } from './settings.js';
import { modes } from './modes.js';
import hotKeys from './hotKeys.js';

export const myInput = {};

myInput.disableTyping = () => {
    myInput.hotKeysActive = true;
    if (!game.input) return;
    ['LEFT', 'RIGHT', 'UP', 'DOWN', 'BACKSPACE'].forEach(key => {
        game.input.keyboard.addCapture(key);
    });
};

myInput.enableTyping = () => {
    myInput.hotKeysActive = false;
    if (!game.input) return;
    game.input.keyboard.clearCaptures();
};

myInput.newProject = () => {
    myInput.disableTyping();
    myInput.pointerEnabled = true;
};

myInput.addHotKey = key => {
    myInput[key.name] = game.input.keyboard.addKey(key.name);
    myInput[key.name].on('down', () => {
        if (myInput.hotKeysActive) {
            key.onDown();
        }
    });
    myInput[key.name].on('up', () => {
        if (key.onUp !== undefined) {
            if (myInput.hotKeysActive) {
                key.onUp();
            }
        }
    });
};

const directions = [
    {name: 'LEFT', angle: Math.PI},
    {name: 'RIGHT', angle: 0},
    {name: 'UP', angle: Math.PI * 0.5},
    {name: 'DOWN', angle: Math.PI * 1.5}
];

myInput.addHotKeys = () => {
    // add hot keys
    hotKeys.forEach(key => myInput.addHotKey(key));

    // handle zoom with + and -
    game.input.keyboard.on('keydown', myInput.handleKeydown);

    // handle arrow keys
    directions.forEach(direction => {
        game.input.keyboard.on('keydown-' + direction.name, () => myInput.handleArrowKey(direction));
    });
};

myInput.handleKeydown = event => {
    if (myInput.pointerEnabled) {
        if (event.key === '-' || (event.key === '_')) cameras.zoomOut();
        if (event.key === '=' || (event.key === '+')) cameras.zoomIn();
    }
};

myInput.handleMouseWheel = (pointer, currentlyOver, dx, dy, dz) => {
    const shouldWheel = myInput.pointerEnabled && settings.preferences.enableMouseScroll;
    if (!shouldWheel) return;

    if (pointer.event.ctrlKey) {
        dy > 0 ? cameras.zoomIn(1.01) : cameras.zoomOut(1.01);
        return;
    }

    const newTheta = utils.myArcTan(dx, dy);
    const myTheta = newTheta + game.cameras.main.rotation;
    const dist = Math.sqrt((dx * dx) + (dy * dy));

    const deltaX = dist * Math.cos(myTheta) / game.cameras.main.zoom;
    const deltaY = dist * Math.sin(myTheta) / game.cameras.main.zoom;

    game.cameras.main.scrollX -= deltaX || 0;
    game.cameras.main.scrollY += deltaY || 0;

};

myInput.handleArrowKey = direction => {
    if (modes.currentMode.name !== 'input') {
        const newTheta = direction.angle + game.cameras.main.rotation;
        game.cameras.main.scrollX += 10 * Math.cos(newTheta) / game.cameras.main.zoom;
        game.cameras.main.scrollY -= 10 * Math.sin(newTheta) / game.cameras.main.zoom;
    }
};

myInput.drag = (pointer, myObject, dragX, dragY) => {
    if (!game.input.activePointer.isDown) return

    const pointerX = game.input.activePointer.position.x;
    const pointerY = game.input.activePointer.position.y;
    const myPoint = utils.returnPoint(pointerX, pointerY);

    myObject.x = myPoint.x - game.clickPoint.x;
    myObject.y = myPoint.y - game.clickPoint.y;
    userimage.updateHandle();
};

myInput.tempBanPointer = () => {
    myInput.pointerEnabled = false;
    setTimeout(() => {
        myInput.pointerEnabled = true;        
    }, 50);
};

myInput.initialize = () => {
    myInput.keyReleased = true;
    myInput.pointerEnabled = false;
    myInput.enableTyping();
    myInput.addHotKeys();
    game.input.on('wheel', myInput.handleMouseWheel);
    game.input.on('drag', myInput.drag);
};

